import { ChangeDetectionStrategy, Component, HostListener, inject, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {Location} from '@angular/common';
import { Store } from '@ngrx/store';
import { TuiDialogContext } from '@taiga-ui/core';
import { TuiPreviewDialogService } from '@taiga-ui/kit';
import { TAIGA_UI_MODULES } from 'app/@taiga-modules';
import { SafePipe } from 'app/widget/index.pipes';
import * as wStateActions from 'app/widget/state/actions';

@Component({
  selector: 'app-capture-detail',
  standalone: true,
  imports: [...TAIGA_UI_MODULES, SafePipe],
  templateUrl: './captureDetail.component.html',
  styleUrl: './captureDetail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaptureDetailComponent implements OnInit, OnDestroy {

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.store$.dispatch(wStateActions.OffsetChanged({offset: 'closefull'}))
    this._location.back();
  }
  
  @ViewChild('preview')
	protected readonly preview?: TemplateRef<TuiDialogContext>;

  store$ = inject(Store);
  private _location = inject(Location);
  private readonly previewDialogService = inject(TuiPreviewDialogService);

  @Input() link?: string
  @Input() price?: string

  @Input() isMobile?: boolean;

  ngOnDestroy(): void {
    if(this.isMobile == undefined) this.store$.dispatch(wStateActions.OffsetChanged({offset: 'closefull'}))
  }

  ngOnInit(): void {
    this.store$.dispatch(wStateActions.OffsetChanged({offset: 'full'}))
    // this.previewDialogService.open(this.preview || '').subscribe();
  }

  ngAfterViewInit(){
    this.previewDialogService.open(this.preview || '').subscribe();
  }

  close(previewInstance: any){
    previewInstance.complete();
    if(this.isMobile == undefined) this.store$.dispatch(wStateActions.OffsetChanged({offset: 'closefull'}))
    this._location.back();
  }

}
